import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";

import DeleteIcon from "src/core/assets/images/icons/delete.svg?react";
import { Spinner } from "src/core/components/custom-ui/spinner";
import { UploadButton } from "src/core/components/ui/upload-button";
import { FolderFileDocumentCode } from "src/core/constants/folder";
import { useFolder } from "src/core/contexts/FolderContext";
import { useMissionLetter } from "src/core/hooks/folder/useMissionLetter";
import { cn } from "src/core/lib/utils";

export const MissionLetter = () => {
  const { t } = useTranslation();
  const { isReadOnly } = useFolder();
  const { form, handleFileChange, isLoading, deleteDoc, fileErrors, handlePreviewDocument } =
    useMissionLetter();
  return (
    <FormProvider {...form}>
      <form>
        <div className="flex items-start w-full mb-10">
          {form.watch(`documents.${FolderFileDocumentCode.MISSION_LETTER}.file`) ? (
            <div className="flex flex-row items-center gap-x-10">
              <div
                role="button"
                onClick={() => {
                  if (form.watch(`documents.${FolderFileDocumentCode.MISSION_LETTER}.fileId`))
                    handlePreviewDocument({
                      id: form.watch(
                        `documents.${FolderFileDocumentCode.MISSION_LETTER}.fileId`
                      ) as string,
                      name: form.watch(
                        `documents.${FolderFileDocumentCode.MISSION_LETTER}.fileName`
                      ) as string,
                    });
                }}
                className={cn("mission-letter-document-card charged")}
              >
                <span className="line-clamp-2">
                  {form.watch(`documents.${FolderFileDocumentCode.MISSION_LETTER}.file`)?.name ||
                    ""}
                </span>
              </div>
              {!isReadOnly &&
                (isLoading ? (
                  <Spinner size="sm" />
                ) : (
                  <DeleteIcon
                    onClick={() => deleteDoc(FolderFileDocumentCode.MISSION_LETTER)}
                    className="cursor-pointer shrink-0 text-input"
                  />
                ))}
            </div>
          ) : form.watch(`documents.${FolderFileDocumentCode.MISSION_LETTER}.fileName`) ? (
            <div className="flex flex-row items-center gap-x-10">
              <div
                role="button"
                onClick={() => {
                  if (form.watch(`documents.${FolderFileDocumentCode.MISSION_LETTER}.fileId`))
                    handlePreviewDocument({
                      id: form.watch(
                        `documents.${FolderFileDocumentCode.MISSION_LETTER}.fileId`
                      ) as string,
                      name: form.watch(
                        `documents.${FolderFileDocumentCode.MISSION_LETTER}.fileName`
                      ) as string,
                    });
                }}
                className={cn("stakeholders-datatable-document-card charged")}
              >
                <span className="line-clamp-2">
                  {form.watch(`documents.${FolderFileDocumentCode.MISSION_LETTER}.fileName`) || ""}
                </span>
              </div>
              {!isReadOnly &&
                (isLoading ? (
                  <Spinner size="sm" />
                ) : (
                  <DeleteIcon
                    onClick={() => deleteDoc(FolderFileDocumentCode.MISSION_LETTER)}
                    className="cursor-pointer shrink-0 text-input"
                  />
                ))}
            </div>
          ) : (
            !isReadOnly && (
              <UploadButton
                disabled={false}
                isExistingChecked={false}
                onChange={(e) => handleFileChange(e, FolderFileDocumentCode.MISSION_LETTER)}
                doc={{ code: FolderFileDocumentCode.MISSION_LETTER }}
                form={form}
                fileErrors={fileErrors}
                label={t("folder.missions.missionLetter.label")}
                isLoading={isLoading}
              />
            )
          )}
        </div>
      </form>
    </FormProvider>
  );
};
